import { helperFont, textoCadaPalabraMayuscula } from "../../utils/helpers/helpers";

interface PersonaProps {
    text: string
    nroDoi
}

const PersonaTag: React.FunctionComponent<PersonaProps> = (prop) => {
    return (
        <>
            <label style={{ ...helperFont }}>
                {/* {textoCadaPalabraMayuscula(prop.text)} */}
                {prop.text}
            </label>
            <div style={{ ...helperFont }}>
                {/* {prop.nroDoi} */}
            </div>
        </>
    );
}

export default PersonaTag;